import { Vue, i18n } from "Common/vue";
import client from "FrontendJsAssets/common/client";

// import components
import Autocomplete from "./../components/vue/Autocomplete.vue";

import "Ui/toggle";
import "./navigation";

window.$_autocomplete = new Vue({
    i18n,
    render: (h) => h(Autocomplete),
}).$mount("#autocomplete");

/*const minicartContainerElement = document.querySelector("#minicart");
window.$_minicart = new Vue({
    i18n,
    render: (h) =>
        h(Minicart, {
            props: {
                priceOfferDescription: minicartContainerElement.getAttribute(
                    "data-price-offer-description"
                ),
            },
        }),
}).$mount("#minicart");*/

document.querySelector(".js-trigger-search").addEventListener("click", (event) => {
    event.preventDefault();

    Event.dispatch("Autocomplete.showForm");
});

function updateMinicartBadgeCount(count) {
    const badge = document.querySelector("[data-count]");
    if (badge) {
        badge.setAttribute("data-count", count);
        badge.textContent = count;
    }
}

const fetchProducts = () => {
    client
        .get("/cart/fetch-products")
        .then((response) => {
            if (!response.data.status) {
                return;
            }

            updateMinicartBadgeCount(response.data.data.count);
        })
        .catch((error) => {});
};

rEvent.on("Cart.totals.after_updated", function (data) {
    updateMinicartBadgeCount(data.quantity);
});

rEvent.on("Cart.removedProduct", function () {
    fetchProducts();
});

rEvent.on("Cart.addedProduct", function () {
    fetchProducts();
});
